import { useStore } from 'react-redux';

const useTelemetryData = () => {
  const store = useStore();

  const getAddress = (robotId) => {
    const { sysId, compId } = store.getState().telemetry[robotId].address;
    return [sysId, compId];
  };

  const getPosition = (robotId) => {
    return store.getState().telemetry[robotId].globalPosition;
  };

  return { getAddress, getPosition };
};

export default useTelemetryData;
